<template>
  <el-input-number
    :model-value="value"
    :min="0"
    :max="10"
    :precision="2"
    :step="0.1"
    class="cost-input"
    @change="$emit('change', $event)"
  />
</template>

<script lang="ts">
export default {
  name: 'CpcInput',
  // eslint-disable-next-line vue/no-deprecated-model-definition
  model: {
    prop: 'value',
    event: 'change',
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['value'],
  emits: ['change'],
}
</script>

<style lang="scss">
.cost-input {
  width: 140px;
  font-weight: 500;

  input {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
